module.exports = __webpack_public_path__ + "img/cert.edfa66f7.png";